export const asuntos = [
    {
        value: 'Lentitud o baja velocidad del servicio',
        label: 'Lentitud o baja velocidad del servicio',
    },
    {
        value: 'Problemas con la antena o baja señal de equipo CPE',
        label: 'Problemas con la antena o baja señal de equipo CPE',
    },
    {
        value: 'Problemas del servicio por ausencia o falla en potencia óptica',
        label: 'Problemas del servicio por ausencia o falla en potencia óptica',
    },
    {
        value: 'Problemas con el router o señal WIFI',
        label: 'Problemas con el router o señal WIFI',
    },
    { value: 'Cambio de clave WIFI', label: 'Cambio de clave WIFI' },
    { value: 'Cambio de domicilio', label: 'Cambio de domicilio' },
    { value: 'Cambio a Fibra Óptica', label: 'Cambio a Fibra Óptica' },
    { value: 'Servicio de IPTV', label: 'Servicio de IPTV' },
    { value: 'Terminación de contrato', label: 'Terminación de contrato' },

    { value: 'Otras PQ', label: 'Otras PQ' },
];
